import { ExternalLink, Users } from 'lucide-react';

const ADMIN_HUB_URL =
  import.meta.env.VITE_ADMIN_HUB_URL ||
  'https://gs-admin-d4hvgqhsgud4e3b0.canadacentral-01.azurewebsites.net';

export default function UsersPage() {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-slate-200 bg-white px-8 py-16 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-purple-50">
        <Users className="h-7 w-7 text-purple-500" />
      </div>
      <h2 className="text-lg font-semibold text-slate-800">Gestion des utilisateurs</h2>
      <p className="mt-2 max-w-sm text-sm text-slate-500 leading-relaxed">
        Les accès aux applications GS sont gérés de façon centralisée depuis{' '}
        <strong className="text-slate-700">GS-Admin</strong>.
      </p>
      <a
        href={`${ADMIN_HUB_URL}/utilisateurs`}
        target="_blank"
        rel="noreferrer"
        className="mt-6 inline-flex items-center gap-2 rounded-lg bg-slate-800 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-slate-700"
      >
        <ExternalLink className="h-4 w-4" />
        Ouvrir GS-Admin
      </a>
    </div>
  );
}
